"use client";

/**
 * NewForm DS hover icon — a cross for "throw this away".
 * On hover the two strokes turn a few degrees against each other and settle,
 * a small shrug rather than a spin.
 * See ./hoverIcon for the colour/animation conventions.
 */

import { type HoverIconProps, HoverIconSvg } from "./hoverIcon";

export function CloseIcon({ size, className }: HoverIconProps) {
  return (
    <HoverIconSvg size={size} className={className}>
      <g className="a-cross">
        <path d="M6.4 6.4 17.6 17.6" />
        <path d="M17.6 6.4 6.4 17.6" />
      </g>
    </HoverIconSvg>
  );
}
